export const CAROUSEL_BREAKPOINTS = [
  {
    breakpoint: 2048,
    settings: {
      slidesToShow: 4.5,
      slidesToScroll: 4,
    },
  },
  {
    breakpoint: 540,
    settings: {
      slidesToShow: 3.5,
      slidesToScroll: 3,
    },
  },
  {
    breakpoint: 440,
    settings: {
      slidesToShow: 2.8,
      slidesToScroll: 2,
    },
  },
  {
    breakpoint: 360,
    settings: {
      slidesToShow: 2.2,
      slidesToScroll: 2,
    },
  },
  {
    breakpoint: 320,
    settings: {
      slidesToShow: 1.8,
      slidesToScroll: 2,
    },
  },
];

export const CAROUSEL_SETTINGS = {
  infinite: false,
  arrows: false,
  dots: false,
  slidesToShow: 4.5,
  slidesToScroll: 4,
  responsive: CAROUSEL_BREAKPOINTS,
};
